import React from 'react';

import FormItemEditorRenderForAutoLookup from './FormItemEditorRenderForAutoLookup';

export default class FormItemBooleanRenderForAutoLookup extends FormItemEditorRenderForAutoLookup
{
	constructor(props) {
		super(props);
	}

	render()
	{
		//disabled={true} 
		let _value = this.props.value;
		let boolvalue = (_value == "true" || _value || _value == "1");
		let _style = {textAlign:'center',marginTop:'0px'};
		return(
			<div className="checkbox" style={_style} ref={ node => this.componentLabel = node }>
              <label style={{paddingLeft:'26px'}}>
                <input type="checkbox" ref="checkdom" checked={boolvalue} defaultChecked={boolvalue} />
              </label>
            </div>
		);
		
	}
}



// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemBooleanRenderForAutoLookup.js